<template>
  <v-avatar
    :size="size"
    class="patient-avatar"
  >
    <span class="patient-avatar__initials" :style="{ fontSize: fontSize }">{{ initials }}</span>
  </v-avatar>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  // Full display name, e.g. "Sarah Williams" — used for the initials.
  name: { type: String, default: '' },
  // Accepted for call-site compatibility; not used for coloring (avatars are
  // uniform: white circle + blue initials in light mode, transparent with a
  // white ring + white initials in dark mode).
  id: { type: [Number, String], default: null },
  size: { type: [Number, String], default: 36 },
});

const initials = computed(() => {
  const parts = String(props.name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
});

const fontSize = computed(() => `${Math.round(Number(props.size) * 0.38)}px`);
</script>

<style scoped>
.patient-avatar {
  background-color: #ffffff !important;
  border: 1px solid #2563eb; /* Praxio blue */
  color: #2563eb;
}

.patient-avatar__initials {
  font-weight: 500;
  letter-spacing: 0.02em;
  line-height: 1;
  color: #2563eb; /* Praxio blue */
  user-select: none;
}

/* Dark theme: no fill, just a white ring with white initials. */
:root.dark .patient-avatar {
  background-color: transparent !important;
  border-color: #ffffff;
}

:root.dark .patient-avatar__initials {
  color: #ffffff;
}
</style>
